import Grid from '@mui/material/Grid2';
import CancelIcon from '@mui/icons-material/Cancel';

const PROBLEMS = [
  {
    title: "Alta probabilidad de error",
    description: "Procesos manuales, múltiples archivos y falta de control generan inconsistencias en la información.",
  },
  {
    title: "Falta de trazabilidad confiable",
    description: "No siempre es posible demostrar el origen, transformación y destino del material.",
  },
  {
    title: "Riesgo regulatorio",
    description: "Certificados rechazados o inconsistentes pueden afectar el cumplimiento ante autoridades.",
  },
  {
    title: "Duplicidad y pérdida de valor",
    description: "Sin control, el mismo material puede contarse más de una vez o perder su trazabilidad.",
  },
];

function ProblemSection() {
  return (
    <section className="bg-[#f8fafc]">
      <div className="max-w-[1200px] mx-auto py-96 px-40">
        <h2 className="text-40 font-extrabold text-[#1E3A8A] text-center mb-64 leading-[1.2]">
          La gestión de residuos hoy tiene más riesgos que certezas
        </h2>
        <Grid container spacing={3}>
          {PROBLEMS.map(({ title, description }) => (
            <Grid key={title} size={{ xs: 12, sm: 6 }}>
              <div className="flex items-start gap-20 bg-white rounded-[14px] p-32 h-full shadow-[0_2px_12px_rgba(0,0,0,0.07)]" style={{ borderLeft: '4px solid #EF4444' }}>
                <CancelIcon className="!text-20 text-[#EF4444] shrink-0 mt-[2px]" />
                <div>
                  <h3 className="text-20 font-bold mb-12 text-[#1b1b1b]">{title}</h3>
                  <p className="text-18 text-[#555] leading-[1.7] m-0">{description}</p>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
}

export default ProblemSection;
